import toast from 'react-hot-toast';
import { useNavigate } from 'react-router';

import { authActions } from '../../redux/slices/authSlice';
import { useAppDisPatch } from '../../redux/store';
import { ACCOUNT, SIGNIN } from '../../routes/routeConstants';

const useOnLogout = () => {
  const navigate = useNavigate();
  const dispatch = useAppDisPatch();

  const logoutUser = () => {
    const onSuccess = () => {
      toast.success('Signed Out');
      localStorage.removeItem('authData');
      localStorage.removeItem('postedJobsCurrentPage');
      sessionStorage.clear();
      dispatch(authActions.reset());
      dispatch({ type: 'LOGOUT' });
      navigate(`${ACCOUNT}/${SIGNIN}`);
    };

    onSuccess();
  };

  return {
    logoutUser,
  };
};

export default useOnLogout;
